import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ErrorPage from "./ErrorPage";
import { homeFor } from "./errorPageHelpers";

const NotFoundPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const signedIn = useSelector((state) => state.auth.signedIn);
  const roles = useSelector((state) => state.auth.user?.roles);
  const home = homeFor(roles);
  // "default" means this page was the first entry, so Back would leave the app.
  const canGoBack = location.key !== "default";

  const actions = signedIn
    ? [
        { label: `Go to ${home.label}`, onClick: () => navigate(home.path) },
        ...(canGoBack ? [{ label: "Back", variant: "ghost", onClick: () => navigate(-1) }] : []),
      ]
    : [{ label: "Sign in", onClick: () => navigate("/user/login") }];

  return (
    <ErrorPage
      code="404"
      eyebrow="Page not found"
      title="This page does not exist"
      message={
        signedIn
          ? "The link may be out of date, or the page may have been renamed. Nothing is wrong with your account — pick a section from the menu to carry on."
          : "The link may be out of date, or the page may have been renamed. Sign in to continue."
      }
      actions={actions}
    />
  );
};

export default NotFoundPage;
